
seedWebApp.controller('ShowPdfCtrl', ['$scope', '$uibModalInstance', '$window', 'StoreService', 'DocService', 'order', 'doc', 'file',
    function ShowPdfCtrl($scope, $uibModalInstance, $window, StoreService, DocService, order, doc, file) {

        console.log('showPdfCtrl');
        //console.log(doc);

        $scope.order= order;
        $scope.doc = doc;
        $scope.file = file;

        //$scope.getPartTranslation = StoreUtils.getPartTranslation;

        $scope.ok = function () {
            $uibModalInstance.close();
        };

        $scope.openNewTab = function (version) {
            var newUrl = version.Image;
            $window.open(newUrl, '_blank');
            $scope.cancel();
        };

        $scope.doPrint = function () {
            $window.print();
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.getIframeSrc = function (filename) {
            return '../../Images/pdfs/' + filename;
        };

        //$scope.imageLoading = true;
        //StoreService.getSpecImage($scope.version.SpecID, $scope.contactID).then(function (response) {
        //    $scope.version.SpecImageUrl = response.data;
        //});

}]);